import type { SVGProps } from 'react';
const SvgSearchDollarStreamlineCore = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={20} height={20} fill="none" viewBox="-0.75 -0.75 20 20" {...props}>
    <desc>{'Search Dollar Streamline Icon: https://streamlinehq.com'}</desc>
    <g stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5}>
      <path d="M4.625 7.729c0-.646.524-1.17 1.169-1.17h5.59c.646 0 1.17.524 1.17 1.17v3.325c0 .645-.524 1.169-1.17 1.169h-5.59a1.17 1.17 0 0 1-1.169-1.169z" />
      <path d="M6.89 6.56V5.555c0-.73.592-1.321 1.322-1.321h.755c.73 0 1.321.592 1.321 1.321V6.56" />
      <path d="M8.59 16.518A7.929 7.929 0 1 0 8.59.66a7.929 7.929 0 0 0 0 15.857M14.192 14.192l3.647 3.648" />
    </g>
  </svg>
);
export default SvgSearchDollarStreamlineCore;
